import { render, staticRenderFns } from "./pqcIndex.vue?vue&type=template&id=d58972fe"
import script from "./pqcIndex.vue?vue&type=script&lang=js"
export * from "./pqcIndex.vue?vue&type=script&lang=js"
import style0 from "./pqcIndex.vue?vue&type=style&index=0&id=d58972fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports